import Timing from "./Timing";

export default class AspectRatio {
	high: number = 1;
	low: number = 1;
	base: string = "width";

	element: HTMLElement;

	constructor(target: HTMLElement, ratio: string) {
		this.element = target;

		let matches = ratio.match(/(\d+):(\d+)/);

		if (!matches) {
			return;
		}

		let [, high, low] = matches;

		this.high = parseInt(high);
		this.low = parseInt(low);

		window.addEventListener("resize", () => {
			this.resize();
		});

		Timing.frame()
			.then(() => Timing.frame())
			.then(() => {
				this.resize();
			});
	}

	resize() {
		if (!this.high || !this.low) {
			return;
		}

		let ratio = this.high / this.low;

		if (this.base === "width") {
			let height = this.element.offsetWidth / ratio;

			this.element.style.height = `${ height }px`;
		} else if (this.base === "height") {
			let width = this.element.offsetHeight * ratio;

			this.element.style.width = `${ width }px`;
		}
	}
}